// 防抖函数
export function debounce(fn: Function, delay=300): Function{
  let timer: number | null = null;
  return function(this: any, ...args: any[]) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

// 节流函数
export function throttle(fn: Function, delay:300): Function{
    let lastTime = 0;
    return function(this: any, ...args: any[]) {
      const now = Date.now();
      if (now - lastTime >= delay) {
        fn.apply(this, args);
        lastTime = now;
      }
    };
}

// 格式化日期
export function formatDate(date: Date | string | number, format:'YYYY-MM-DD'): string{
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    
    return format
      .replace('YYYY', String(year))
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
}
      
/**
 * 格式化当前系统时间
 * @param format 格式模板，默认 "YYYY-MM-DD HH:mm:ss"
 * @returns 格式化后的时间字符串
 */
export function getSystemTime(format = "YYYY-MM-DD HH:mm:ss"): string {
  const now = new Date();

  const replacements: Record<string, string> = {
    'YYYY': String(now.getFullYear()),
    'MM': String(now.getMonth() + 1).padStart(2, '0'),
    'DD': String(now.getDate()).padStart(2, '0'),
    'HH': String(now.getHours()).padStart(2, '0'),
    'mm': String(now.getMinutes()).padStart(2, '0'),
    'ss': String(now.getSeconds()).padStart(2, '0'),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => replacements[match]);
}

// 深拷贝对象
export function deepClone<T>(obj: T):T{
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}

//添加监听事件
export function addListenerEvent(eventType: string, back: (event?: unknown) => void) {
  window.listenEvent.on(eventType, back);
}

//发送监听事件
export function sendListenerEvent(eventType:string, data = {}) {
  window.listenEvent.emit(eventType, data);
}

//移除监听事件
export function offListenerEvent(eventType:string) {
  window.listenEvent.off(eventType);
}

/**
 * 从给定的URL中提取查询参数并返回一个包含键值对的对象
 * @param {string} url
 * @returns {Object}
 */
export function getQuery() {
  let url = window.location.search;
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj:Record<string,string> = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}


// 随机生成风向和风速
export const createRandomWind = () => {
  return {
    direction:Math.floor(Math.random()*8),
    speed:'0.3,2.0'
  }
}

/**
 * 生成指定长度的随机码（数字+字母）
 * @param length 随机码长度
 * @returns 随机码字符串
 */
export function generateRandomCode(length = 11){
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

export function downloadFile(response: any, fileSuffix: 'docx' | 'pdf' | 'xlsx'){
  let filename = `报告_${Date.now()}.${fileSuffix}`
  const contentDisposition = response.headers['content-disposition']
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (filenameMatch && filenameMatch[1]) {
      // 去除引号
      filename = filenameMatch[1].replace(/['"]/g, '');
      // 处理 URL 编码的文件名
      filename = decodeURIComponent(filename);
    }
  }
  const blobUrl = window.URL.createObjectURL(response.data);  
  // 创建下载链接
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // 释放 blob URL
  window.URL.revokeObjectURL(blobUrl);
}

// 根据偏差类型获取颜色
export const getDeviationColor = (key: string): string => {
    const colorMap: Record<string, string> = {
        'height': '#6BA4FF',
        'position': '#D57D0F',
        'timeDeviation': '#46B65B',
        'headAngle': '#FDE043',
        'angle': '#D279D3',
        'speed': '#38B6C7'
    }
    return colorMap[key] || '#6BA4FF'
}

export const getWindDirection = (direction: number) => {
  const windDirectiones = ['北风','东北风','东风','东南风','南风','西南风','西风','西北风','随机风']
  return windDirectiones[direction] || ''
}

export const getWindSpeed = (speed: number ) => {
  const windSpeeds = [{value:'0~0.2',label:'无'},{value:'0.3~1.5',label:'1级'},{value:'1.6~3.3',label:'2级'},{value:'3.4~5.4',label:'3级'},{value:'5.5~7.9',label:'4级'},{value:'8.0~10.7',label:'5级'}]
  console.log('getWindSpeed----',windSpeeds[speed],speed)
  return windSpeeds[speed] || {value:'0',label:''}
}

export * from './storage'